<template>
  <v-row class="my-0">
    <v-col class="primary--text subtitle-2 pt-0" cols="12">
      <p class="mb-0 font-weight-black">{{ item.name }}</p>
      <p class="mb-0">
        <span class="font-weight-black">{{ $tc('total', 1) }}:</span>
        {{ item.total }}
      </p>
      <p class="mb-0">
        <span class="font-weight-black">{{ $tc('customer', 1) }}:</span>
        {{ client.name }}
      </p>
      <p class="mb-0">
        <span class="font-weight-black">{{ $t('address') }}:</span>
        {{ client.address.address }}
      </p>
      <p class="mb-0">
        <span class="font-weight-black">{{ $t('city') }}:</span>
        {{ client.address.city }}
      </p>
      <p class="mb-0">
        <span class="font-weight-black">{{ $t('state') }}:</span>
        {{ client.address.state }}
      </p>
      <p class="mb-0">
        <span class="font-weight-black">{{ $t('zip_code') }}:</span>
        {{ client.address.zip_code }}
      </p>
      <p class="mb-3">
        <span class="font-weight-black">{{ $tc('phone', 1) }}:</span>
        {{ client.phone }}
      </p>
    </v-col>
  </v-row>
</template>
<script>
export default {
  props: {
    item: {
      required: true,
      type: Object
    },
    client: {
      required: true,
      type: Object
    }
  }
}
</script>
